/**
 * InfoCard - simple container that has selected and disabled states renders passed in content
 */
import React from 'react';
import cx from 'classnames';

import './InfoCard.less';

type InfoCardProps = {
  isDisabled?: boolean;
  /** Actionable cards - expand on hover and have borders applied */
  isActionable?: boolean;
  /** Selected state adds teal border to the info card */
  isSelected?: boolean;
  /** Children will be rendered within the card */
  children: React.ReactNode;
  /** Classname will be added to container */
  className?: string;
};

const InfoCard: React.FC<InfoCardProps> = ({
  isActionable,
  isDisabled,
  isSelected,
  children,
  className,
}) => (
  <div
    className={cx(
      'zola-ui',
      'info-card',
      className,
      { 'is-selected': isSelected },
      { 'is-actionable': isActionable },
      { 'is-disabled': isDisabled }
    )}
  >
    {children}
  </div>
);

export default InfoCard;
